import { createBrowserRouter, createRoutesFromElements, Route, RouterProvider } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import * as Sentry from "@sentry/react";

import Quiz from './pages/quiz';
import { useTranslation } from 'react-i18next';
// import QuizResult from './pages/quiz-result';

const pathname = window.location.pathname;
const appVersion = import.meta.env.VITE_RELEASE_VERSION;

// Sentry.init({
// 	dsn: "https://c233a76b11db68278b0a5e17662ba5eb@o4503918113783808.ingest.us.sentry.io/4508164505206784",
// 	integrations: [],
// 	beforeSend(event) {
// 		if (event.exception && event.exception.values) {
// 			const stackFrames = event.exception.values.flatMap(value => value.stacktrace?.frames || []);
// 			// Check if the error is from YOUR React app
// 			const isFromYourApp = stackFrames.some(frame => frame.filename && frame.filename.includes(`index-v${appVersion}.js`));

// 			// Ignore errors if they originate from other scripts
// 			if (!isFromYourApp) {
// 				return null;
// 			}
// 		}
// 		return event;
// 	},
// 	tracesSampleRate: 0.5, // Adjust the sampling rate based on your requirements
// 	release: import.meta.env.VITE_RELEASE_VERSION,
// });

const queryClient = new QueryClient();

const router = createBrowserRouter(
	createRoutesFromElements(
		<Route path={pathname}>
			<Route index element={<Quiz />} />,
			{/* <Route path="/result" element={<QuizResult />} /> */}
		</Route>
	)
)

function App() {
	const { t } = useTranslation()


	return (
		<>
			<QueryClientProvider client={queryClient}>
				<RouterProvider router={router} />
			</QueryClientProvider>
		</>
	);
}

export default App
